import { render, staticRenderFns } from "./awardsInfo.vue?vue&type=template&id=062caa38&scoped=true&"
import script from "./awardsInfo.vue?vue&type=script&lang=js&"
export * from "./awardsInfo.vue?vue&type=script&lang=js&"
import style0 from "./awardsInfo.vue?vue&type=style&index=0&id=062caa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062caa38",
  null
  
)

export default component.exports